import React from 'react';
import i18n from 'util/i18n';

interface ButtonProps {
  formName: string
  onClick: () => void
}

const PDFButton: React.FC<ButtonProps> = ({ formName, onClick }) => (
  <button type="button" className="usa-button" onClick={onClick}>
    {i18n.t('login.locked.formButton.buttonText', { formName })}
  </button>
);

export default PDFButton;
